import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'tellent-assistant-brand-mark',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './tellent-assistant-brand-mark.component.html',
  styleUrl: './tellent-assistant-brand-mark.component.less',
  host: {
    '[style.width.px]': 'size()',
    '[style.height.px]': 'size()',
  },
})
export class TellentAssistantBrandMarkComponent {
  public size = input<16 | 18 | 20 | 24 | 28 | 32>(24);
}
